export default "/images/vendor/flag-icon-css/flags/4x3/re.svg?c97ad6daf51758d0df7963b8cda8d4a8";